import { ValidIconName } from '../components';
import { intl } from '../lib';

/**
 * Provide a custom icon by mimeType for a file/document
 * @param mimeType
 * @author rsb
 */
export const getIconByMimeType = (
  mimeType: string | undefined
): ValidIconName => {
  switch (mimeType) {
    case 'image/png':
      return 'file-png';
    case 'image/jpeg':
      return 'file-jpg';
    case 'text/plain':
      return 'file-txt';
    case 'text/csv':
      return 'file-csv';
    case 'text/xml':
    case 'application/xml':
      return 'file-xml';
    case 'application/pdf':
      return 'file-pdf';
    case 'text/html':
      return 'file-html';
    case 'image/gif':
      return 'file-gif';
    case 'application/dicom':
      return 'x-ray';
  }

  if (mimeType) {
    if (mimeType.includes('image/')) {
      return 'file-dicom';
    }

    if (mimeType.includes('audio/')) {
      return 'file-audio';
    }

    if (mimeType.includes('video/')) {
      return 'file-video';
    }

    if (
      mimeType.includes('freearc') ||
      mimeType.includes('word') ||
      mimeType.includes('document')
    ) {
      return 'file-doc';
    }
  }

  return 'file-empty';
};

/**
 * Gets the correct icon for the given gender string.
 *
 * The supported gender values are: (case insensitive)
 * - 'm'
 * - 'f'
 * - 'o'
 * - 'a'
 *
 * @author agd
 * @author Zuzana Stichova
 * @param gender the gender to get the icon for. This is simply a string since many of our types only have a string
 * @return the correct icon or `null` if no suitable icon for the given string exists
 */
export const getGenderIcon = (
  gender: string | undefined
): { 'aria-label': string; iconName: ValidIconName } | null => {
  if (gender === '') {
    console.error('Empty gender provided');
    return null;
  }
  const genderCode = gender?.charAt(0).toUpperCase();
  switch (genderCode) {
    case 'M':
      return {
        'aria-label': intl('gender.M'),
        iconName: 'gender-male'
      };
    case 'F':
      return {
        'aria-label': intl('gender.F'),
        iconName: 'gender-female'
      };
    case 'A':
    case 'O':
      return {
        'aria-label': intl('gender.O'),
        iconName: 'gender-other'
      };
    default:
      return null;
  }
};

/**
 * The path to the default avatar for an individual healthcare provider
 */
export const defaultIndividualProviderAvatarPath =
  '/o/WebResourceProviderHook/icons/avatar.png';
//TODO replace SHUI icons
export const defaultIndividualProviderShuiAvatarPath =
  '/o/WebResourceProviderHook/icons/shui_avatar.svg';
